import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ResourceService } from 'sce-core';

@Injectable()
export class HomeService {

  constructor(private http: HttpClient,
    private resourceService: ResourceService) { }

  public fetchRssFeed(): Observable<any> {
    const url: string = 'api/feed/1/link';
    const response$: any = this.http.get(url)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return Observable.throw(this.resourceService.get('server_err_pop_list')
          + this.resourceService.get(error.message));
      });
    return response$;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/home.service.ts